import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDollar(value) {
  if (value === null || value === undefined || value === '') return '';
  const num = typeof value === 'string' ? parseFloat(value.replace(/[^0-9.-]/g, '')) : value;
  if (isNaN(num)) return '';
  return '$' + num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export function parseDollar(str) {
  if (!str) return '';
  return str.replace(/[^0-9]/g, '');
}

export function formatPhone(value) {
  if (!value) return '';
  const digits = value.replace(/\D/g, '').slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export const STATUS_COLORS = {
  open: 'bg-blue-50 text-blue-700 border-blue-200',
  awarded: 'bg-amber-50 text-amber-700 border-amber-200',
  in_progress: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  completed: 'bg-violet-50 text-violet-700 border-violet-200',
  closed: 'bg-red-50 text-red-700 border-red-200',
  canceled: 'bg-red-50 text-red-700 border-red-200',
};

export const STATUS_ORDER = { open: 0, awarded: 1, in_progress: 2, completed: 3, closed: 4, canceled: 5 };

export function statusLabel(status) {
  if (!status) return '';
  if (status === 'closed') return 'Closed';
  return status.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());
}
